// src/styles/SideNav.styles.js
import styled from 'styled-components';

// Wrapper for the entire side navigation, including the logo
// export const SideNavWrapper = styled.div`
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     justify-content: flex-start;
//     width: 200px;
//     min-width: 200px;
//     background-color: #f5eddc; /* Light pastel blue f1f5f8 f5eddc*/ 
//     padding: 0px;
//     box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
// `;

export const SideNavWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'collapsed',
})`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: ${({ collapsed }) => (collapsed ? '58px' : '200px')};
  min-width: ${({ collapsed }) => (collapsed ? '40px' : '200px')};
  background-color: #f5eddc;
  padding: 0;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease;
`;


// Container for the logo to prevent shrinking
// export const LogoContainer = styled.div`
//     width: 100%; /* Full width of SideNav */
//     margin-bottom: 20px;
//     display: flex;
//     justify-content: center;
//     flex-shrink: 0; /* Prevent the container from shrinking */
// `;

export const LogoContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'collapsed',
})`
  width: 100%;
  margin-bottom: 20px;
  display: ${({ collapsed }) => (collapsed ? 'none' : 'flex')};
  justify-content: center;
  flex-shrink: 0;
`;

// Logo styling to maintain consistent size
export const LogoImage = styled.img`
    width: 80%; /* Scales to 80% of SideNav width */
    max-width: 160px;
    height: auto;
    flex-shrink: 0; /* Prevent the logo from shrinking */
`;

export const NavItem = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})`
  padding: 20px 16px;
  width: calc(100%);
  
  border-radius: 3px;
  background-color: ${({ active }) => (active ? 'transparent' : 'transparent')};
  color: ${({ active }) => (active ? '#007bff' : '#fffff')};
  border: ${({ active }) => (active ? '2px solid #007bff' : 'none')};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e0e7ff;
    color: #007bff;
  }
`;

export const ToggleButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 2px;
  padding-right: 2px;
`;

export const ToggleButton = styled.button`
  background: none;
  border: 0px solid;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
  &:hover {
    color:rgb(216, 228, 240);
  }
`;
